module.exports = __webpack_public_path__ + "static/media/file-earmark-arrow-down.afd5ff67.svg";